
export class PracticionerRole {
  id?: number;
  code?: string;
  display?: string;

  constructor(data?) {
    if (data) {
      this.id = data.id;
      for (let item of data.code) {
        for (let ch of item.coding) {
          this.code = ch.code;
          this.display = ch.display;
        }
      }
    }
  }

  public static fromDTO?(data) {
    const pacient = new PracticionerRole();
    return pacient;
  }

  public toDTO?() {
    const dto: any = {};

    return dto;
  }

}
